import * as tslib_1 from "tslib";
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { AssetService, ModalService, } from '@services';
import { BehaviorSubject, of, } from 'rxjs';
import { filter, finalize, switchMap, } from 'rxjs/operators';
import { AssetModalComponent } from './modals';
var ɵ0 = urlStateHandler;
var AssetsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AssetsPageComponent, _super);
    function AssetsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingModal$ = new BehaviorSubject(false);
        _this._modalService = _this._injector.get(ModalService);
        return _this;
    }
    AssetsPageComponent.prototype.openModal = function (model) {
        var _this = this;
        this.loadingModal$.next(true);
        var clone$ = !!model ?
            this._service.getInstance(model.id, ['RobotValues']) :
            of(undefined);
        clone$.pipe(switchMap(function (clone) { return _this._modalService
            .openModal(AssetModalComponent, clone, { autoFocus: false })
            .afterClosedResult(); }), filter(function (result) { return !!result; }), finalize(function () { return _this.loadingModal$.next(false); }))
            .subscribe(function () { return _this._refresh$.next(); });
    };
    Object.defineProperty(AssetsPageComponent.prototype, "allowDelete", {
        get: function () {
            return this._grid.selectionManager.hasValue() &&
                this._grid.selectionManager.selected.every(function (asset) { return asset.canBeDeleted; });
        },
        enumerable: true,
        configurable: true
    });
    return AssetsPageComponent;
}(ODataGridComponent));
export { AssetsPageComponent };
export { ɵ0 };
